module.exports = __webpack_public_path__ + "static/media/error_light.c2179c65.png";